import { GetHealthInsuranceByPatient } from 'domain/usecases/patient/get-health-insurance-by-patient'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteGetHealthInsuranceByPatient
  implements GetHealthInsuranceByPatient
{
  constructor(private readonly patientNewRepository: PatientNewRepository) {}

  get(
    params: GetHealthInsuranceByPatient.Params
  ): Promise<GetHealthInsuranceByPatient.Model> {
    return this.patientNewRepository.getHealthInsuranceByPatient(params)
  }
}
